import { createAsyncThunk } from '@reduxjs/toolkit';
import InfluencerService from '../../../api/services/InfluencerService';

export const getInfluencers = createAsyncThunk('influencer/getInfluencers', async ({ page, search, sortBy }) => {
  return await InfluencerService.getInfluencers(page, search, sortBy);
});

export const getInfluencerById = createAsyncThunk('influencer/getInfluencerById', async ({ id }) => {
  return await InfluencerService.getInfluencerById(id);
});

export const getInfluencerFeed = createAsyncThunk(
  'influencer/getInfluencerFeed',
  async ({ influencerId, limit, cursor }) => {
    return await InfluencerService.getInfluencerFeed(influencerId, limit, cursor);
  },
);
